import { Action } from '../../actions';
import { ADD_INTERNAL_MARKETER_PRODUCT } from '../../actions/marketer/internal/addInternalMarketerProduct';
import { ADD_INTERNAL_MARKETER_PRODUCT_ACCESS } from '../../actions/marketer/internal/addInternalMarketerProductAccess';
import { LOAD_INTERNAL_MARKETER } from '../../actions/marketer/internal/loadInternalMarketer';
import { REMOVE_INTERNAL_MARKETER_PRODUCT } from '../../actions/marketer/internal/removeInternalMarketerProduct';
import { REMOVE_INTERNAL_MARKETER_PRODUCT_ACCESS } from '../../actions/marketer/internal/removeInternalMarketerProductAccess';
import { RESET_INTERNAL_MARKETER_EDIT_PRODUCT } from '../../actions/marketer/internal/resetInternalMarketerEditProduct';
import { SORT_INTERNAL_MARKETER_PRODUCTS } from '../../actions/marketer/internal/sortInternalMarketerProducts';
import { UPDATE_INTERNAL_MARKETER } from '../../actions/marketer/internal/updateInternalMarketer';
import { UPDATE_INTERNAL_MARKETER_EDIT_PRODUCT } from '../../actions/marketer/internal/updateInternalMarketerEditProduct';
import { UPDATE_INTERNAL_MARKETER_GRID_OFFSET } from '../../actions/marketer/internal/updateInternalMarketerGridOffset';
import { UPDATE_INTERNAL_MARKETER_PAGE_STATUS } from '../../actions/marketer/internal/updateInternalMarketerPageStatus';
import { UPDATE_INTERNAL_MARKETER_PRODUCT } from '../../actions/marketer/internal/updateInternalMarketerProduct';
import { UPDATE_INTERNAL_MARKETER_PRODUCT_ACCESS } from '../../actions/marketer/internal/updateInternalMarketerProductAccess';
import { MarketersPageStates, MarketerState, ServerMarketerAccess } from '../../typings/marketers';

import { addInternalMarketerProduct } from './internal/addInternalMarketerProduct';
import { addInternalMarketerProductAccess } from './internal/addInternalMarketerProductAccess';
import { loadInternalMarketer } from './internal/loadInternalMarketer';
import { removeInternalMarketerProduct } from './internal/removeInternalMarketerProduct';
import { removeInternalMarketerProductAccess } from './internal/removeInternalMarketerProductAccess';
import { resetInternalMarketerEditProduct } from './internal/resetInternalMarketerEditProduct';
import { sortInternalMarketerProducts } from './internal/sortInternalMarketerProducts';
import { updateInternalMarketer } from './internal/updateInternalMarketer';
import { updateInternalMarketerEditProduct } from './internal/updateInternalMarketerEditProduct';
import { updateInternalMarketerGridOffset } from './internal/updateInternalMarketerGridOffset';
import { updateInternalMarketerPageStatus } from './internal/updateInternalMarketerPageStatus';
import { updateInternalMarketerProduct } from './internal/updateInternalMarketerProduct';
import { updateInternalMarketerProductAccess } from './internal/updateInternalMarketerProductAccess';

export const getMarketerInitialState = (): MarketerState => ({
    marketer: {
        id: '',
        login: '',
        fullName: '',
        ownProducts: []
    },
    pageStatus: MarketersPageStates.LOADING,
    editProduct: {
        id: '',
        productName: '',
        productLogin: '',
        access: ServerMarketerAccess.READONLY,
        placeIds: [],
        isRemoving: false,
        isSaved: true
    },
    gridOffset: 0
});

export function internalMarketer(state: MarketerState = getMarketerInitialState(), action: Action): MarketerState {
    switch (action.type) {
        case LOAD_INTERNAL_MARKETER:
            return loadInternalMarketer(state, action);

        case UPDATE_INTERNAL_MARKETER_EDIT_PRODUCT:
            return updateInternalMarketerEditProduct(state, action);

        case RESET_INTERNAL_MARKETER_EDIT_PRODUCT:
            return resetInternalMarketerEditProduct(state, action);

        case ADD_INTERNAL_MARKETER_PRODUCT_ACCESS:
            return addInternalMarketerProductAccess(state, action);

        case UPDATE_INTERNAL_MARKETER:
            return updateInternalMarketer(state, action);

        case ADD_INTERNAL_MARKETER_PRODUCT:
            return addInternalMarketerProduct(state, action);

        case UPDATE_INTERNAL_MARKETER_PRODUCT_ACCESS:
            return updateInternalMarketerProductAccess(state, action);

        case UPDATE_INTERNAL_MARKETER_PRODUCT:
            return updateInternalMarketerProduct(state, action);

        case UPDATE_INTERNAL_MARKETER_PAGE_STATUS:
            return updateInternalMarketerPageStatus(state, action);

        case REMOVE_INTERNAL_MARKETER_PRODUCT_ACCESS:
            return removeInternalMarketerProductAccess(state, action);

        case REMOVE_INTERNAL_MARKETER_PRODUCT:
            return removeInternalMarketerProduct(state, action);

        case UPDATE_INTERNAL_MARKETER_GRID_OFFSET:
            return updateInternalMarketerGridOffset(state, action);

        case SORT_INTERNAL_MARKETER_PRODUCTS:
            return sortInternalMarketerProducts(state, action);

        default:
            return state;
    }
}
